export default __webpack_public_path__ + "static/media/logo.7fc19b5e.png";